import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "days", "dates", "schedule_type", "ordersCloseDay", "ordersCloseTime", "conflictWarning", "conflictText" ]

  connect() {
	this.update_schedule_type();
	this.disable_inputs_scrool();
	this.updateOrdersCloseTimeRequired();

	this.boundCheckConflicts = this.checkConflicts.bind(this);
	this.element.addEventListener("change", this.boundCheckConflicts);
	this.element.addEventListener("input", this.boundCheckConflicts);
	this.checkConflicts();
  }

  disconnect() {
	if (this.boundCheckConflicts) {
	  this.element.removeEventListener("change", this.boundCheckConflicts);
	  this.element.removeEventListener("input", this.boundCheckConflicts);
	}
  }

  // The schedule type is a set of radio cards (one target per radio); legacy
  // accounts without the fixed-dates option render none and stay weekly.
  scheduleTypeValue() {
	const checked = this.schedule_typeTargets.find(radio => radio.checked);
	return checked ? checked.value : "days_of_the_week";
  }

  update_schedule_type(event) {
	if (!this.hasDaysTarget || !this.hasDatesTarget) return;

	if (this.scheduleTypeValue() == "fixed_dates") {
		this.datesTarget.classList.remove("hidden");
		this.daysTarget.classList.add("hidden");
	} else {
		this.daysTarget.classList.remove("hidden");
		this.datesTarget.classList.add("hidden");
	}

  }


	disable_inputs_scrool(e) {
		var inputs = document.querySelectorAll('input[type="number"]');
		inputs.forEach(function (element) {
			element.parentElement.addEventListener("wheel", (e) => {
				if (e.target.nodeName == "INPUT")
					e.preventDefault();
			})
		});
	}

	updateOrdersCloseTimeRequired() {
		if (!this.hasOrdersCloseDayTarget || !this.hasOrdersCloseTimeTarget) return;

		const hasCloseDay = this.ordersCloseDayTarget.value !== "";
		this.ordersCloseTimeTarget.required = hasCloseDay;

		const label = this.ordersCloseTimeTarget.closest('.sm\\:grid')?.querySelector('label');
		if (label) {
			const existingAsterisk = label.querySelector('.text-red-500');
			if (hasCloseDay && !existingAsterisk) {
				label.insertAdjacentHTML('beforeend', '<span class="text-red-500 ml-1">*</span>');
			} else if (!hasCloseDay && existingAsterisk) {
				existingAsterisk.remove();
			}
		}
	}

	// ---- Live schedule conflict detection ---------------------------------

	// Reads the current form state into the same shape as the sibling payload.
	currentSchedule() {
		const type = this.scheduleTypeValue();

		let weekdays = [];
		let dates = [];

		if (type === "fixed_dates") {
			const datesField = this.element.querySelector('input[name="operating_day[dates]"]');
			if (datesField && datesField.value) {
				dates = datesField.value.split(",").map(s => s.trim()).filter(Boolean);
			}
		} else {
			const dayMap = { sunday: 0, monday: 1, tuesday: 2, wednesday: 3, thursday: 4, friday: 5, saturday: 6 };
			for (const [name, wday] of Object.entries(dayMap)) {
				const box = this.element.querySelector(`input[type="checkbox"][name="operating_day[${name}]"]`);
				if (box && box.checked) weekdays.push(wday);
			}
		}

		const open = this.readMinutes('input[name="operating_day[open_time]"]');
		const close = this.readMinutes('input[name="operating_day[close_time]"]');

		return { weekdays, dates, open, close, allDay: open === null || close === null };
	}

	readMinutes(selector) {
		const field = this.element.querySelector(selector);
		if (!field || !field.value) return null;
		const match = field.value.match(/^(\d{1,2}):(\d{2})/);
		if (!match) return null;
		return parseInt(match[1], 10) * 60 + parseInt(match[2], 10);
	}

	wdayOf(dateStr) {
		const d = new Date(`${dateStr}T00:00:00`);
		return isNaN(d) ? null : d.getDay();
	}

	daysOverlap(a, b) {
		if (a.weekdays.some(w => b.weekdays.includes(w))) return true;
		if (a.dates.some(d => b.dates.includes(d))) return true;
		if (a.weekdays.length && b.dates.some(d => a.weekdays.includes(this.wdayOf(d)))) return true;
		if (b.weekdays.length && a.dates.some(d => b.weekdays.includes(this.wdayOf(d)))) return true;
		return false;
	}

	timesOverlap(a, b) {
		if (a.allDay || b.allDay) return true;
		return a.open < b.close && b.open < a.close;
	}

	siblings() {
		const raw = this.data.get("siblings");
		if (!raw) return [];
		try {
			return JSON.parse(raw);
		} catch (e) {
			return [];
		}
	}

	checkConflicts() {
		if (!this.hasConflictWarningTarget) return;

		const siblings = this.siblings();
		const current = this.currentSchedule();

		const conflicting = siblings.find(sibling => {
			const s = {
				weekdays: sibling.weekdays || [],
				dates: sibling.dates || [],
				open: sibling.open != null ? this.toMinutes(sibling.open) : null,
				close: sibling.close != null ? this.toMinutes(sibling.close) : null,
				allDay: sibling.allDay
			};
			return this.daysOverlap(current, s) && this.timesOverlap(current, s);
		});

		if (conflicting) {
			this.conflictWarningTarget.classList.remove("hidden");
			this.conflictWarningTarget.classList.add("flex");
			if (this.hasConflictTextTarget) {
				const template = this.conflictWarningTarget.dataset.messageTemplate || "This schedule overlaps with an existing service time (%{schedule}).";
				this.conflictTextTarget.textContent = template.replace("%{schedule}", conflicting.label || "");
			}
		} else {
			this.conflictWarningTarget.classList.add("hidden");
			this.conflictWarningTarget.classList.remove("flex");
		}
	}

	toMinutes(value) {
		const match = String(value).match(/^(\d{1,2}):(\d{2})/);
		if (!match) return null;
		return parseInt(match[1], 10) * 60 + parseInt(match[2], 10);
	}

}
